/**
 * NRO Cart Upsell Add-ons
 * Handles "+ Add" clicks in the cart drawer's upsell strip.
 * Adds the selected addon to cart, then re-renders the drawer using
 * Dawn's CartDrawer.renderContents() so the item list and bubble count
 * are both updated without a page reload.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nro-cart-upsell__add');
    if (!btn || btn.disabled) return;

    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = '…';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('add_failed');
      return r.json();
    })
    .then(function () {
      return fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble');
    })
    .then(function (r) { return r.json(); })
    .then(function (sections) {
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
        cartDrawerEl.renderContents({ sections: sections });
      }
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = originalText;
    });
  });
})();
